<template>
  <div v-if="updateExists" class="pwa-update-prompt" dir="rtl">
    <div class="pwa-update-content">
      <p>نسخه جدید برنامه آماده است. برای دریافت آخرین تغییرات، صفحه را رفرش کنید.</p>
      <div class="pwa-update-actions">
        <button class="btn-update" @click="refreshApp">بروزرسانی</button>
        <button class="btn-later" @click="dismiss">بعداً</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PwaUpdatePrompt',
  data () {
    return {
      updateExists: false,
      registration: null
    }
  },
  mounted () {
    document.addEventListener('sw-updated', this.showUpdatePrompt)
  },
  beforeUnmount () {
    document.removeEventListener('sw-updated', this.showUpdatePrompt)
  },
  methods: {
    showUpdatePrompt (event) {
      this.registration = event.detail
      this.updateExists = true
    },
    refreshApp () {
      this.updateExists = false
      window.location.reload()
    },
    dismiss () {
      this.updateExists = false
    }
  }
}
</script>

<style scoped>
.pwa-update-prompt {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 9999;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 16px;
  font-family: 'IRANSansXFaNum-Light', sans-serif;
  direction: rtl;
}

.pwa-update-content p {
  margin: 0 0 12px 0;
  color: #2a3550;
  font-size: 14px;
}

.pwa-update-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn-update {
  background: #5186dd;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
}

.btn-update:hover {
  background: #4073c9;
}

.btn-later {
  background: #f8faff;
  color: #5186dd;
  border: 1px solid #5186dd;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
}

.btn-later:hover {
  background: #e8f0ff;
}
</style>
